// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vwxe","questions":"styles_questions__3dUJO","footer":"styles_footer__2KB7T"};